import React from "react";
import { gli } from "../mock";
import { ShieldCheck, Home, Scale, Check, BadgeCheck } from "lucide-react";

const icons = { ShieldCheck, Home, Scale };

export default function Gli() {
  return (
    <section id="gli" className="bg-[#F4F0E9] py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <p className="mb-3 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#B08D57]">
          <span className="h-px w-8 bg-[#B08D57]" /> {gli.eyebrow}
        </p>
        <h2 className="max-w-2xl font-serifDisplay text-[34px] leading-tight text-[#26241F] lg:text-[46px]">
          {gli.title}
        </h2>
        <p className="mt-4 max-w-2xl text-[16px] leading-relaxed text-[#6e6a62]">{gli.intro}</p>

        <div className="mt-7 flex flex-wrap gap-3">
          {gli.badges.map((b) => (
            <span key={b} className="inline-flex items-center gap-2 rounded-full border border-[#d8cfbd] bg-[#FBF9F5] px-4 py-2 text-[14px] font-semibold text-[#26241F]">
              <BadgeCheck className="h-4 w-4 text-[#B08D57]" /> {b}
            </span>
          ))}
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {gli.cards.map((c, idx) => {
            const Icon = icons[c.icon];
            const highlight = idx === 0;
            return (
              <div
                key={c.title}
                className={`flex flex-col rounded-3xl border p-7 transition-all duration-300 ${
                  highlight
                    ? "border-[#B08D57] bg-[#26241F] text-white"
                    : "border-[#e0d8c8] bg-[#FBF9F5] text-[#26241F]"
                }`}
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${highlight ? "bg-[#B08D57] text-[#26241F]" : "bg-[#26241F] text-[#B08D57]"}`}>
                  {Icon && <Icon className="h-6 w-6" />}
                </span>
                <h3 className="mt-4 text-[20px] font-semibold">{c.title}</h3>
                <div className={`mt-1 text-[13px] font-medium uppercase tracking-wider ${highlight ? "text-[#d9be8e]" : "text-[#B08D57]"}`}>
                  {c.subtitle}
                </div>
                <ul className="mt-5 space-y-3">
                  {c.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-[14px] leading-relaxed">
                      <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${highlight ? "bg-[#B08D57] text-[#26241F]" : "bg-[#26241F] text-white"}`}>
                        <Check className="h-3 w-3" />
                      </span>
                      <span className={highlight ? "text-white/90" : "text-[#403d35]"}>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <p className="mt-6 text-[13px] leading-relaxed text-[#9a9488]">{gli.footnote}</p>
      </div>
    </section>
  );
}
